import React from "react";
import { connect } from "react-redux";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Logo } from "../profile/logo";
import { FullName } from "../profile/full-name";
import { ModalFooter, Submit } from "../../../react-components/modals/modal-form-elements";
import {
  OnBoardingFounderAction,
  ProfileModuleState,
  EditProfilePayload,
  EditProfileAction,
} from "../redux/profile/types";
import { onBoardingFounder, editProfile } from "../redux/profile/actions";
import { AppState } from "../../../redux";
import { Responsibility } from "../profile/responsibility";

interface MapStateProps {
  fullName: string;
  inProgress: boolean;
  user: Person;
}

interface MapDispatchProps {
  editProfile: (payload: EditProfilePayload) => EditProfileAction;
  onBoardingFounder: () => OnBoardingFounderAction;
}

type Props = MapDispatchProps & MapStateProps;

const Component = (props: Props) => {
  const { user, fullName, inProgress, editProfile, onBoardingFounder } = props;
  const title = "Create your Founder profile";

  const hasAtLeastTwoNames = /\w +\w/.test(fullName);
  const isValid = hasAtLeastTwoNames;

  React.useEffect(() => {
    if (!user) {
      return;
    }
    editProfile({ subject: user });
  }, [editProfile, user]);

  const onSubmit = React.useCallback(() => {
    onBoardingFounder();
  }, [onBoardingFounder]);

  return (
    <Container>
      <div className="subtitle">{title}</div>
      <Logo isRequired={false} />
      <FullName />
      <Responsibility />
      <ModalFooter>
        <Submit
          onClick={onSubmit}
          disabled={false}
          className={isValid ? `` : "disabled"}
          isSubmitting={inProgress}
          title="Continue"
        />
      </ModalFooter>
    </Container>
  );
};

const Container = ({ children }) => {
  return <div className="onboarding-founder">{children}</div>;
};

const mapState = (state: AppState & ProfileModuleState) => ({
  user: state.account.user,
  profileImage: state.profile.profileImage,
  fullName: state.profile.fullName,
  inProgress: state.cache.inProgress["onboarding-founder"],
});

const mapDispatch = {
  editProfile: editProfile,
  onBoardingFounder: onBoardingFounder,
};

export const OnBoardingFounder = connect(mapState, mapDispatch)(Component);
